// extracted by mini-css-extract-plugin
export var auto = "_2m-1";
export var spinner = "_2m-0";